// src/RnInterviewPrep.js
import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
} from "@mui/material";
import Editor from "@monaco-editor/react";

const objectiveQuestions = [
  {
    id: 1,
    question: "What is React Native?",
    options: ["Framework", "Library", "Language", "IDE"],
    answer: "Framework",
  },
  {
    id: 2,
    question: "Which hook is used for state management?",
    options: ["useEffect", "useState", "useRef", "useContext"],
    answer: "useState",
  },
];

const codingQuestions = [
  {
    id: 1,
    question: "Write a function to reverse a string.",
    starterCode: `function reverseString(str) {
  // your code here
}
console.log(reverseString("hello"));`,
  },
  {
    id: 2,
    question: "Write a function to find factorial of a number.",
    starterCode: `function factorial(n) {
  // your code here
}
console.log(factorial(5));`,
  },
];

const RnInterviewPrep = () => {
  const [tab, setTab] = useState(0);

  // Objective states
  const [objIndex, setObjIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});

  // Coding states
  const [codeIndex, setCodeIndex] = useState(0);
  const [codeSolutions, setCodeSolutions] = useState(
    codingQuestions.reduce((acc, q) => {
      acc[q.id] = q.starterCode;
      return acc;
    }, {})
  );

  const handleOptionChange = (qid, value) => {
    setSelectedOptions({ ...selectedOptions, [qid]: value });
  };

  return (
    <Box sx={{ p: 3, bgcolor: "#111", color: "#eee", minHeight: "100vh" }}>
      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={(e, newValue) => setTab(newValue)}
        textColor="secondary"
        indicatorColor="secondary"
        sx={{
          "& .MuiTab-root": { color: "#aaa" },
          "& .Mui-selected": { color: "#fff !important" },
        }}
      >
        <Tab label="Objectives" />
        <Tab label="Coding" />
      </Tabs>

      {/* Objective Questions */}
      {tab === 0 && (
        <Paper sx={{ p: 3, mt: 2, bgcolor: "#1e1e1e" }}>
          <Typography variant="h6" gutterBottom>
            Q{objIndex + 1}. {objectiveQuestions[objIndex].question}
          </Typography>
          <RadioGroup
            value={selectedOptions[objectiveQuestions[objIndex].id] || ""}
            onChange={(e) =>
              handleOptionChange(
                objectiveQuestions[objIndex].id,
                e.target.value
              )
            }
          >
            {objectiveQuestions[objIndex].options.map((opt, i) => (
              <FormControlLabel
                key={i}
                value={opt}
                control={<Radio sx={{ color: "#888" }} />}
                label={opt}
                sx={{ color: "#eee" }}
              />
            ))}
          </RadioGroup>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Button
              variant="outlined"
              disabled={objIndex === 0}
              onClick={() => setObjIndex(objIndex - 1)}
              sx={{ color: "#fff", borderColor: "#666" }}
            >
              Prev
            </Button>
            <Button
              variant="contained"
              disabled={objIndex === objectiveQuestions.length - 1}
              onClick={() => setObjIndex(objIndex + 1)}
              sx={{ bgcolor: "#4cafef" }}
            >
              Next
            </Button>
          </Box>
        </Paper>
      )}

      {/* Coding Questions */}
      {tab === 1 && (
        <Paper sx={{ p: 3, mt: 2, bgcolor: "#1e1e1e" }}>
          <Typography variant="h6" gutterBottom>
            Q{codeIndex + 1}. {codingQuestions[codeIndex].question}
          </Typography>
          <Editor
            height="300px"
            language="javascript"
            theme="vs-dark"
            value={codeSolutions[codingQuestions[codeIndex].id]}
            onChange={(value) =>
              setCodeSolutions({
                ...codeSolutions,
                [codingQuestions[codeIndex].id]: value,
              })
            }
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Button
              variant="outlined"
              disabled={codeIndex === 0}
              onClick={() => setCodeIndex(codeIndex - 1)}
              sx={{ color: "#fff", borderColor: "#666" }}
            >
              Prev
            </Button>
            <Button
              variant="contained"
              disabled={codeIndex === codingQuestions.length - 1}
              onClick={() => setCodeIndex(codeIndex + 1)}
              sx={{ bgcolor: "#4cafef" }}
            >
              Next
            </Button>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default RnInterviewPrep;
